module.exports = __webpack_public_path__ + "assets/vehicle_map_coupe.82b865e1.svg";